import React, {useState} from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import {handleModalState} from '@pluto/utils';
import ArtworkImage from './ArtworkImage';
import CreateArtworkDialog from './CreateArtworkDialog';
import wrap from 'wraptile';
import {DeleteSnapshotAction} from './Redux/SnapshotActions';
import {getDeleteConfirmationDialog} from 'QCTools/QCToolsArtwork/QCToolsArtworkThumbnails/QCToolsArtworkThumbnailsHandlers';

export interface CreateArtworkDialogContainerProps {
    url: string;
    deleteSnapshot: DeleteSnapshotAction;
    videoFileId: number;
    id: number;
    qcId: number;
}

export const handleModalOpen = wrap(
    (
        setArtworkDialogIsOpen: (value: boolean) => void,
        setCurrentArtwork: (value: string) => void,
        url: string
    ) => {
        setArtworkDialogIsOpen(true);
        setCurrentArtwork(url);
    }
);

export const areEqual = (
    prevProps: CreateArtworkDialogContainerProps,
    nextProps: CreateArtworkDialogContainerProps
) => {
    const {url: prevUrl} = prevProps;
    const {url: nextUrl} = nextProps;
    const [prevBaseUrl] = prevUrl.split('?');
    const [nextBaseUrl] = nextUrl.split('?');

    return prevBaseUrl === nextBaseUrl;
};

export const handleDeleteSnapshot = wrap(
    (
        deleteSnapshot: DeleteSnapshotAction,
        videoFileId: number,
        id: number,
        setModalVisible: Function,
        qcId: number
    ) => {
        setModalVisible(false);
        return deleteSnapshot(qcId, id, videoFileId);
    }
);

function CreateArtworkDialogContainer(props: CreateArtworkDialogContainerProps) {
    const {url, deleteSnapshot, id, videoFileId, qcId} = props;
    const [artworkDialogIsOpen, setArtworkDialogIsOpen] = useState<boolean>(false);
    const [currentArtwork, setCurrentArtwork] = useState<string>('');
    const [modalVisible, setModalVisible] = useState(false);
    const artworkModalClose = handleModalState(setArtworkDialogIsOpen, false);
    const onDeleteClick = handleDeleteSnapshot(
        deleteSnapshot,
        videoFileId,
        id,
        setModalVisible,
        qcId
    );

    return (
        <div className="snapshot-wrapper" key={url}>
            {getDeleteConfirmationDialog(modalVisible, setModalVisible, onDeleteClick)}
            <CreateArtworkDialog
                snapshotId={id}
                artworkDialogIsOpen={artworkDialogIsOpen}
                artworkModalClose={artworkModalClose}
                currentArtwork={currentArtwork}
            />
            <div className="control-buttons">
                <button
                    onClick={handleModalOpen(
                        setArtworkDialogIsOpen,
                        setCurrentArtwork,
                        url
                    )}
                    className="control-button control-button_create"
                >
                    Create Artwork
                </button>
                <DeleteIcon
                    className="control-button control-button_delete"
                    onClick={handleModalState(setModalVisible, true)}
                />
            </div>
            <ArtworkImage src={url} />
        </div>
    );
}

export default React.memo(CreateArtworkDialogContainer, areEqual);
